import parse from "html-react-parser";
import { useEffect, useRef } from "react";

const Preview = ({ generatedHtml }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      const scripts = containerRef.current.querySelectorAll("script");
      scripts.forEach((script) => {
        const newScript = document.createElement("script");
        newScript.textContent = script.textContent;
        document.body.appendChild(newScript);
        document.body.removeChild(newScript);
      });
    }
  }, [generatedHtml]);

  return <div ref={containerRef} className="preview-container">{parse(generatedHtml || "")}</div>;
};

export default Preview;
